import { createRoot } from 'react-dom/client';
import React from 'react';
import { ConfigProvider, ThemeConfig } from 'antd';
import { HashRouter, Outlet, Route, Routes } from 'react-router-dom';

import './index/index.css';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs from 'dayjs';
import ja_JP from 'antd/locale/ja_JP';
import { MainLayout } from './index/main_layout';
import { PermissionName } from './valueobject/permissionName';
import { MainView } from './index/pages/main/main_view';
import { ScheduleView } from './index/pages/schedule/schedule_view';
import { IssuePage } from './index/pages/issue';
import { TaskCSVRegistPage } from './index/pages/task_csvregist';
import { DefaultSessionProvider } from './context/session/default_session_state';
import { LoginPage } from './index/pages/login';
import { TaskListPage } from './index/pages/task_list';
import { Restricted } from './index/components/restricted';
import { IndicatorProvider } from './context/indicator';
import { IndexProvider } from './index_provider';
import { TaskEditView } from './index/pages/task_edit';
import { NotificationView } from './index/pages/notification';
import { BusinessTypeKeys } from './constant';
import {AccountListPage} from "./index/pages/account_list";
import {AccountRegisterPage} from "./index/pages/account_register";
import {PasswordChangePage} from "./index/pages/password_change";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Root
 */
const container = document.getElementById('root');
const root = createRoot(container);
const App: React.FC = () => {
  const theme: ThemeConfig = { token: { colorPrimary: '#00B96B', zIndexPopupBase: 9000 } };

  return (
    <ConfigProvider theme={theme} locale={ja_JP}>
      <DefaultSessionProvider>
          <IndexProvider>
          <HashRouter>
          <IndicatorProvider>
            <Routes>
              <Route
                element={
                  <MainLayout>
                    <Outlet />
                  </MainLayout>
                }
              >
                <Route
                  path="/main"
                  element={
                    <Restricted permission={PermissionName.DASHBOARD} element={<MainView />} />
                  }
                />
                <Route
                   path="/notification"
                   element={
                       <Restricted permission={PermissionName.NOTIFICATION} element={<NotificationView />} />
                   }
                />
                <Route
                  path="/schedule"
                  element={
                    <Restricted permission={PermissionName.SCHEDULE} element={<ScheduleView />} />
                  }
                />
                <Route
                  path="/task_list"
                  element={
                    <Restricted permission={PermissionName.SCHEDULE} element={<TaskListPage />} />
                  }
                />
                <Route
                  path="/issue"
                  element={
                    <Restricted permission={PermissionName.ISSUE} readwrite={true} element={<IssuePage />} />
                  }
                />
                <Route
                  path="/issue/:workId/details/:planId"
                  element={
                    <Restricted permission={PermissionName.ISSUE} element={<IssuePage />} />
                  }
                />
                <Route
                  path="/task_csvregist"
                  element={
                    <Restricted permission={PermissionName.BULK_INSERT_PLAN} businessTypes={[BusinessTypeKeys.cleaning, BusinessTypeKeys.greening]} element={<TaskCSVRegistPage />} />
                  }
                />
                  <Route
                      path="/task_edit"
                      element={
                      <Restricted permission={PermissionName.WORK_PLAN}
                                  element={<TaskEditView />} />
                     }
                  />
                <Route
                  path="/account_list"
                  element={
                    <Restricted permission={PermissionName.ACCOUNT_MANAGER}
                                element={<AccountListPage />} />
                  }
                />
                <Route
                  path="/account_regist"
                  element={
                    <Restricted permission={PermissionName.ACCOUNT_MANAGER}
                                element={<AccountRegisterPage />} />
                  }
                />
                <Route
                  path="/password_change"
                  element={
                    <Restricted permission={PermissionName.USER}
                                element={<PasswordChangePage />} />
                  }
                />
              </Route>
              <Route path="*" element={<LoginPage />} />
            </Routes>
          </IndicatorProvider>
          </HashRouter>
          </IndexProvider>
      </DefaultSessionProvider>
    </ConfigProvider>
  );
};

root.render(<App />);
